import { JSX } from 'react';
import BankIcon from '../assets/BankIcon';

const bankLogoMapping: Record<string, string> = {
  AMEX: '/bank-logos/amex.svg',
  ANDA: '/bank-logos/anda.svg',
  BBVA: '/bank-logos/bbva.svg',
  BROU: '/bank-logos/brou.svg',
  CABAL: '/bank-logos/cabal.svg',
  CREDITEL: '/bank-logos/creditel.svg',
  FUCAC: '/bank-logos/fucac.svg',
  HSBC: '/bank-logos/hsbc.svg',
  ITAU: '/bank-logos/itau.svg',
  MIDINERO: '/bank-logos/mi-dinero.svg',
  OCA: '/bank-logos/oca.svg',
  PASSCARD: '/bank-logos/pass-card.svg',
  PIX: '/bank-logos/pix.svg',
  PREX: '/bank-logos/prex.svg',
  SANTANDER: '/bank-logos/santander.svg',
  SCOTIABANK: '/bank-logos/scotiabank.svg',
  SISTARBANC: '/bank-logos/sistarbanc.svg',
  TARJETAD: '/bank-logos/tarjeta-d.svg',
};

const normalizeIssuer = (issuer: string): string => {
  const trimmedIssuer = issuer.trim().toUpperCase();

 switch (trimmedIssuer) {
    case 'AMERICAN EXPRESS':
    case 'AMEX':
      return 'AMEX';
    case 'ANDA':
      return 'ANDA';
    case 'BBVA':
      return 'BBVA';
    case 'BANCO REPUBLICA ORIENTAL DEL URUGUAY':
    case 'BROU':
      return 'BROU';
    case 'CABAL':
      return 'CABAL';
    case 'CREDITEL':
      return 'CREDITEL';
    case 'FUCAC VERDE COOPERATIVA DE AHORRO Y CREDITO':
    case 'FUCAC':
      return 'FUCAC';
    case 'HSBC':
      return 'HSBC';
    case 'ITAU':
      return 'ITAU';
    case 'MI DINERO':
    case 'MIDINERO':
      return 'MIDINERO';
    case 'OCA':
      return 'OCA';
    case 'PASSCARD':
    case 'PASS CARD':
      return 'PASSCARD';
    case 'PIX':
      return 'PIX';
    case 'PREX':
      return 'PREX';
    case 'SANTANDER':
      return 'SANTANDER';
    case 'SCOTIABANK':
      return 'SCOTIABANK';
    case 'SISTARBANC':
      return 'SISTARBANC';
    case 'TARJETA D':
    case 'TARJETAD':
      return 'TARJETAD';
    case 'UNKNOWN':
    default:
      return trimmedIssuer;
    }
};
const capitalizeIssuerName = (issuer: string): string => {
  const words = issuer
    .split(' ')
    .map((word) => (word.match(/^(SA|S\.A\.)$/i) ? word.toUpperCase() : word.toLowerCase()));

  return words
    .map((word) => (word === 'SA' || word === 'S.A.' ? word : word.charAt(0).toUpperCase() + word.slice(1)))
    .join(' ');
};


const getBankLogoAndImage = (issuer: string | null, onlyImage: boolean = false): JSX.Element => {
  if (!issuer || issuer.toUpperCase() === 'UNKNOWN') {
    return (
      <>
        <BankIcon />
        {!onlyImage && <span>Banco no reportado</span>}
      </>
    );
  }

  const normalizedIssuer = normalizeIssuer(issuer);
  const logoSrc = bankLogoMapping[normalizedIssuer];
  const capitalizedIssuer = <span>{capitalizeIssuerName(issuer)}</span>;

  if (logoSrc) {
    return (
      <>
        <img src={logoSrc} alt={issuer} style={{ maxHeight: '20px', maxWidth: '60px' }} />
        {!onlyImage && capitalizedIssuer}
      </>
    );
  }

  return (
    <>
      <BankIcon />
      {!onlyImage && capitalizedIssuer}
    </>
  );
};

export const issuerCardHelper = {
  bankLogoMapping,
  getBankLogoAndImage,
};
